import React, { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";

const navItems = ["home", "about", "skills", "projects", "contact"];

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 24);

    onScroll();
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "border-b border-white/10 bg-[#07111f]/78 backdrop-blur-xl"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <Link
          to="home"
          smooth
          duration={500}
          offset={-72}
          className="flex cursor-pointer items-center gap-3"
        >
          <img
            src="/logo.svg"
            alt="Shubham logo"
            className="h-11 w-11 rounded-xl object-contain"
          />
          <div>
            <p className="font-['Sora'] text-sm uppercase tracking-[0.35em] text-slate-200">
              Shubham
            </p>
            <p className="mt-1 text-xs uppercase tracking-[0.28em] text-slate-500">
              Full Stack Developer
            </p>
          </div>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {navItems.map((item) => (
            <Link
              key={item}
              to={item}
              smooth
              duration={500}
              offset={-80}
              className="nav-link cursor-pointer text-sm uppercase tracking-[0.22em] text-slate-300 transition hover:text-white"
            >
              {item}
            </Link>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href="/resume.html"
            target="_blank"
            rel="noreferrer"
            className="rounded-full border border-white/15 px-5 py-2 text-sm font-medium text-slate-100 transition hover:border-[#f59e0b]/70 hover:text-white"
          >
            Resume
          </a>
        </div>

        <button
          type="button"
          onClick={() => setIsOpen((current) => !current)}
          className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-slate-100 md:hidden"
          aria-label="Toggle navigation menu"
        >
          {isOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
        </button>
      </div>

      {isOpen && (
        <div className="border-t border-white/10 bg-[#07111f]/96 px-5 pb-6 pt-4 backdrop-blur-2xl md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-5">
            {navItems.map((item) => (
              <Link
                key={item}
                to={item}
                smooth
                duration={500}
                offset={-72}
                onClick={() => setIsOpen(false)}
                className="cursor-pointer border-b border-white/8 pb-4 text-sm uppercase tracking-[0.28em] text-slate-300"
              >
                {item}
              </Link>
            ))}

            <a
              href="/resume.html"
              target="_blank"
              rel="noreferrer"
              className="mt-2 inline-flex w-fit rounded-full border border-white/15 px-5 py-2 text-sm font-medium text-slate-100"
            >
              Open resume
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default NavBar;
